module.exports = __webpack_public_path__ + "img/STAGE3D-1.jpg";